module.exports = __webpack_public_path__ + "img/centimeter.7e24feb4.jpg";